import { Injectable } from '@angular/core';
import SecureStorage from 'secure-web-storage';
import CryptoJS from 'crypto-js';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class SecureService {
    constructor() {}

    public secureLocalStorage = new SecureStorage(localStorage, {
        hash: function hash(key): any {
            key = CryptoJS.SHA256(key, environment.encryptionSecretKey);
            return key.toString();
        },
        // Encrypt the localstorage data
        encrypt: function encrypt(data) {
            data = CryptoJS.AES.encrypt(data, environment.encryptionSecretKey);
            data = data.toString();
            return data;
        },
        // Decrypt the encrypted data
        decrypt: function decrypt(data) {
            data = CryptoJS.AES.decrypt(data, environment.encryptionSecretKey);
            data = data.toString(CryptoJS.enc.Utf8);
            return data;
        },
    });

    public secureSessionStorage = new SecureStorage(sessionStorage, {
        hash: function hash(key): any {
            key = CryptoJS.SHA256(key, environment.encryptionSecretKey);
            return key.toString();
        },
        // Encrypt the localstorage data
        encrypt: function encrypt(data) {
            data = CryptoJS.AES.encrypt(data, environment.encryptionSecretKey);
            data = data.toString();
            return data;
        },
        // Decrypt the encrypted data
        decrypt: function decrypt(data) {
            data = CryptoJS.AES.decrypt(data, environment.encryptionSecretKey);
            data = data.toString(CryptoJS.enc.Utf8);
            return data;
        },
    });
}
